import React from 'react';

// Skeleton for category buttons
export const CategorySkeleton = () => (
  <div className="categoryButtons">
    {[1, 2, 3].map(i => (
      <button key={i} className="skeleton" style={{ minHeight: '100px', width: 'calc(33.333% - 8px)' }}>
        <div className="skeleton skeleton-circle" style={{ width: '55px', height: '55px', margin: '0 auto 8px' }}></div>
        <div className="skeleton skeleton-text small" style={{ width: '80%', margin: '0 auto' }}></div>
      </button>
    ))}
  </div>
);

// Skeleton for recipe cards
export const RecipeCardSkeleton = () => (
  <div className="recipe-card">
    <div style={{ padding: '20px' }}>
      <div className="recipe-header">
        <div style={{ flex: 1, paddingRight: '10px' }}>
          <div className="skeleton skeleton-text large" style={{ width: '80%', marginBottom: '10px' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '60%' }}></div>
        </div>
        <div className="skeleton skeleton-circle" style={{ width: '24px', height: '24px' }}></div>
      </div>
      <div className="skeleton skeleton-text" style={{ width: '90%', marginTop: '10px' }}></div>
      <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
    </div>
  </div>
);

// Skeleton for recipe list page
export const RecipeListSkeleton = () => (
  <>
    {/* Logo skeleton */}
    <div className="logo">
      <div className="skeleton skeleton-circle" style={{ width: '60px', height: '60px', margin: '0 auto 15px' }}></div>
      <div className="skeleton skeleton-text large" style={{ width: '250px', height: '32px', margin: '0 auto' }}></div>
    </div>

    {/* Categories skeleton */}
    <div className="categoryList">
      <div className="skeleton skeleton-text large" style={{ width: '120px', height: '24px', margin: '0 auto 20px' }}></div>
      <CategorySkeleton />
    </div>

    {/* Recipe list skeleton */}
    <div className="recipe-list-container">
      <div className="recipeList">
        <div className="skeleton skeleton-text large" style={{ width: '100px', height: '28px', margin: '0 auto 30px' }}></div>
        
        {/* Letter section skeleton */}
        <div className="letter-section">
          <div className="skeleton skeleton-text large" style={{ width: '30px', height: '32px', marginBottom: '20px' }}></div>
          <div className="recipe-grid">
            {[1, 2, 3, 4, 5, 6].map(i => (
              <RecipeCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </>
);

// Skeleton for recipe detail page controls
export const RecipeControlsSkeleton = () => (
  <div className="controls">
    <div className="header-controls">
      <div className="skeleton skeleton-button" style={{ width: '150px' }}></div>
      <div className="right-side-controls">
        <div className="accessibility-buttons-right">
          {[1, 2, 3].map(i => (
            <div key={i} className="skeleton skeleton-button" style={{ width: '120px', height: '60px' }}></div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// Skeleton for ingredients section
export const IngredientsSkeleton = () => (
  <div className="ingredients-section">
    <div className="skeleton skeleton-text large" style={{ width: '120px', marginBottom: '20px' }}></div>
    
    <div className="section expanded">
      <div className="section-header">
        <div className="skeleton skeleton-text" style={{ width: '100px' }}></div>
        <div className="skeleton skeleton-button" style={{ width: '120px' }}></div>
      </div>
      
      {/* Table skeleton for desktop */}
      <table>
        <thead>
          <tr>
            <th style={{ width: '50px' }}></th>
            <th><div className="skeleton skeleton-text" style={{ width: '80px' }}></div></th>
            <th><div className="skeleton skeleton-text" style={{ width: '60px' }}></div></th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5].map(i => (
            <tr key={i}>
              <td><div className="skeleton skeleton-circle" style={{ width: '16px', height: '16px' }}></div></td>
              <td><div className="skeleton skeleton-text" style={{ width: '80%' }}></div></td>
              <td><div className="skeleton skeleton-text" style={{ width: '60%' }}></div></td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile cards skeleton */}
      <div className="mobile-ingredients">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="mobile-ingredient-card">
            <div className="mobile-checkbox-row">
              <div className="skeleton skeleton-circle" style={{ width: '16px', height: '16px' }}></div>
              <div className="skeleton skeleton-text small" style={{ width: '100px' }}></div>
            </div>
            <div className="skeleton skeleton-text" style={{ width: '90%', marginBottom: '6px' }}></div>
            <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Skeleton for directions section
export const DirectionsSkeleton = () => (
  <div className="directions-section">
    <div className="skeleton skeleton-text large" style={{ width: '100px', marginBottom: '20px' }}></div>
    
    <ol>
      {[1, 2, 3, 4].map(i => (
        <li key={i} style={{ padding: '15px', marginBottom: '15px', backgroundColor: '#ffffff', borderRadius: '8px', border: '2px solid #adb5bd' }}>
          <div className="direction-content">
            <div className="step-number-with-audio">
              <div className="skeleton skeleton-circle" style={{ width: '30px', height: '30px' }}></div>
              <div className="skeleton skeleton-circle" style={{ width: '20px', height: '20px' }}></div>
            </div>
            <div className="direction-text" style={{ flex: 1 }}>
              <div className="skeleton skeleton-text" style={{ width: '95%', marginBottom: '8px' }}></div>
              <div className="skeleton skeleton-text" style={{ width: '85%', marginBottom: '8px' }}></div>
              <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
            </div>
          </div>
        </li>
      ))}
    </ol>
  </div>
);

// Skeleton for full recipe detail page
export const RecipeDetailSkeleton = () => (
  <>
    <RecipeControlsSkeleton />
    
    <div className="container">
      <div className="header-with-button">
        <div className="skeleton skeleton-text large" style={{ width: '250px', height: '24px', margin: '0 auto' }}></div>
        <div className="skeleton skeleton-button" style={{ width: '180px' }}></div>
      </div>

      <div className="content">
        <IngredientsSkeleton />
        <DirectionsSkeleton />
      </div>
    </div>
  </>
);

export default {
  CategorySkeleton,
  RecipeCardSkeleton,
  RecipeListSkeleton,
  RecipeControlsSkeleton,
  IngredientsSkeleton,
  DirectionsSkeleton,
  RecipeDetailSkeleton
};